<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from './O3DG2'
export default {
  mixins: [O3DG2]
}
</script>

<style>
</style>
